import { elements } from "../variables/elements"
import { params } from "../variables/params"
import { getAppeals } from "../api/getAppeals"

export const maybeAddAppeal = () => {
  if (params.appeal) {
    elements.appealCode.value = params.appeal
    getAppeals(params.appeal)
  }
}